import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'

const PrivateRoutes = () => {
  const QuotationsPage = lazy(() => import('../modules/apps/quotation-management/QuotationsPage'))
  const ConceptsPage = lazy(() => import('../modules/apps/concept-management/ConceptsPage'))
  const MatricesPage = lazy(() => import('../modules/apps/matrix-management/MatricesPage'))
  const ClientsPage = lazy(() => import('../modules/apps/client-management/ClientsPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))
  const CoinsPage = lazy(() => import('../modules/apps/coin-management/CoinsPage'))
  const SettingsPage = lazy(() => import('../modules/apps/settings-management/SettingsPage'))
  const TypesPage = lazy(() => import('../modules/apps/type-management/TypesPage'))
  const FamiliesPage = lazy(() => import('../modules/apps/family-management/FamiliesPage'))
  const UnitsPage = lazy(() => import('../modules/apps/unit-management/UnitsPage'))
  const TermsPage = lazy(() => import('../modules/apps/term-management/TermsPage'))
  const LogsPage = lazy(() => import('../modules/apps/logs-management/LogsPage'))
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/apps/quotation-management/quotations' />} />

        {/* Lazy Modules */}
        <Route
          path='apps/quotation-management/*'
          element={
            <SuspensedView>
              <QuotationsPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/concept-management/*'
          element={
            <SuspensedView>
              <ConceptsPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/matrix-management/*'
          element={
            <SuspensedView>
              <MatricesPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/client-management/*'
          element={
            <SuspensedView>
              <ClientsPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/coin-management/*'
          element={
            <SuspensedView>
              <CoinsPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/type-management/*'
          element={
            <SuspensedView>
              <TypesPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/family-management/*'
          element={
            <SuspensedView>
              <FamiliesPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/unit-management/*'
          element={
            <SuspensedView>
              <UnitsPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/term-management/*'
          element={
            <SuspensedView>
              <TermsPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/settings-management/*'
          element={
            <SuspensedView>
              <SettingsPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/logs-management/*'
          element={
            <SuspensedView>
              <LogsPage />
            </SuspensedView>
          }
        />

        <Route
          path='/my-profile'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
